import XLSX from "xlsx";
import XLSXStyle from "xlsx-style";
import FileSaver from "file-saver";

function setExlStyle(data, width) {
	let borderAll = {
		//单元格外侧框线
		top: {
			style: "thin",
		},
		bottom: {
			style: "thin",
		},
		left: {
			style: "thin",
		},
		right: {
			style: "thin",
		},
	};
	data["!cols"] = [];

	for (let key in data) {
		if (data[key] instanceof Object) {
			data[key].s = {
				border: borderAll,
				alignment: {
					horizontal: "center", //水平居中对齐
					vertical: "center",
					wrapText: true, // 自动换行
				},
				font: {
					sz: 10,
				},
				bold: false,
				numFmt: 0,
			};
			data["!cols"].push({
				wpx: width || 100,
			});
		}
		if (key == "A1") {
			data[key].s = {
				font: {
					sz: 16, //设置标题的字号
				},
				alignment: {
					horizontal: "center",
					vertical: "center",
					wrapText: true,
				}, //设置标题水平竖直方向居中，并自动换行展示
				// fill: {
				//     fgColor: { rgb: 'ebebeb' }//设置标题单元格的背景颜色
				// }
			};
		}
	}
	return data;
}
function addRangeBorder(range, ws) {
	let cols = [
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"V",
		"W",
		"X",
		"Y",
		"Z",
		"AA",
		"AB",
		"AC",
		"AD",
		"AE",
		"AF",
		"AG",
		"AH",
		"AI",
		"AJ",
		"AK",
	];
	range.forEach((item) => {
		let style = {
			s: {
				border: {
					top: {
						style: "thin",
					},
					left: {
						style: "thin",
					},
					bottom: {
						style: "thin",
					},
					right: {
						style: "thin",
					},
				},
			},
		};
		// 处理合并行
		for (let i = item.s.c; i <= item.e.c; i++) {
			ws[`${cols[i]}${Number(item.e.r) + 1}`] =
				ws[`${cols[i]}${Number(item.e.r) + 1}`] || style;
			// 处理合并列
			for (let k = item.s.r + 2; k <= item.e.r + 1; k++) {
				ws[cols[i] + k] = ws[cols[k] + item.e.r] || style;
			}
		}
	});
	return ws;
}
function exportToExcel(exportDom, sheetName, exportName, type, merges) {
	// exportDom:导出的dom元素/导出数据  sheetName:sheet页名字  exportName:导出文件名  type:导出类型
	let ws = null
	if (type && type === 'data') {
		ws = XLSX.utils.aoa_to_sheet(exportDom);
	} else {
		ws = XLSX.utils.table_to_sheet(exportDom);

	}
	//创建一个workbook对象
	let wb = XLSX.utils.book_new();
	//把worksheet对象添加进workbook对象，第三个参数是excel中sheet的名字
	XLSX.utils.book_append_sheet(wb, ws, sheetName);
	setExlStyle(wb["Sheets"][sheetName]); // 设置列宽 字号等
	// 数据生成的 可能没有!merges  可以手动加
	if (!wb["Sheets"][sheetName]["!merges"]) {
		wb["Sheets"][sheetName]["!merges"] = merges || [];
	}
	// 处理合并单元格 边框问题
	addRangeBorder(wb["Sheets"][sheetName]["!merges"], wb["Sheets"][sheetName]);
	let wb_out = XLSXStyle.write(wb, {
		type: "buffer",
	});

	try {
		FileSaver.saveAs(
			new Blob([wb_out], {
				type: "application/octet-stream",
			}),
			`${exportName}.xlsx`
		); //trade-publish.xlsx 为导出的文件名
	} catch (e) {
	}
	return wb_out;
}
function downloadFile(url,fileName)
{
	const link = document.createElement('a')
    link.href = url
    link.download = fileName
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}
function downloadBase64(base64, filename) {
  const link = document.createElement('a')
  link.href = `data:application/octet-stream;base64,${base64}`
  link.download = filename
  link.click()
}

export { exportToExcel, setExlStyle, addRangeBorder,downloadFile,downloadBase64 };
